import React from 'react';
import SubscriberForm from './subscriber-form';
import styles from './subscribe-section.module.css';

export default function SubscribeSection() {
  return (
    <section id="subscribe" className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className="section-header center">Beyond the Book</h2>
        </div>
        <SubscriberForm />
      </div>
    </section>
  );
}
